export default __webpack_public_path__ + "static/media/karma.05b8180c.svg";